import { GatewayId } from '@pillar-portal/database/dist/frontend';
import { z } from 'zod';
import {
    IpgSystemId,
    IpwSystemId,
    ThirdPartySystemId,
    type IpgSystemId as IpgSystemIdType,
    type IpwSystemId as IpwSystemIdType,
    type ThirdPartySystemId as ThirdPartySystemIdType,
} from '../types/third-party-system.enums';

function coerceNumericIdentifier(value: unknown): unknown {
    if (value === null || value === undefined) {
        return value;
    }
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
        return value;
    }
    return numericValue;
}

export const ThirdPartySystemIdSchema: z.ZodType<ThirdPartySystemIdType> = z.preprocess(
    coerceNumericIdentifier,
    z.union([
        z.literal(ThirdPartySystemId.CORE),
        z.literal(ThirdPartySystemId.DEALERTRACK),
        z.literal(ThirdPartySystemId.PCPARTPICKER),
        z.literal(ThirdPartySystemId.VALOR_US),
    ])
);

export const NonCoreThirdPartySystemIdSchema: z.ZodType<ThirdPartySystemIdType> = z.preprocess(
    coerceNumericIdentifier,
    z.union([
        z.literal(ThirdPartySystemId.DEALERTRACK),
        z.literal(ThirdPartySystemId.PCPARTPICKER),
        z.literal(ThirdPartySystemId.VALOR_US),
    ])
);

export const GatewayIdSchema: z.ZodType<GatewayId> = z.preprocess(
    coerceNumericIdentifier,
    z.union([z.literal(GatewayId.VALOR_US)])
);

export const NumericIpgSystemIdSchema: z.ZodType<IpgSystemIdType> = z.preprocess(
    coerceNumericIdentifier,
    z.union([z.literal(IpgSystemId.VALOR_US)])
);

export const NumericIpwSystemIdSchema: z.ZodType<IpwSystemIdType> = z.preprocess(
    coerceNumericIdentifier,
    z.union([z.literal(IpwSystemId.DEALERTRACK), z.literal(IpwSystemId.PCPARTPICKER)])
);
